import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./OurFactory.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ImgBox from "../../../Component/ReuseComponent/ImgBox/ImgBox";
import ILTCBox from "../../../Component/ReuseComponent/ITCBox/ILTCBOX";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";

export default function OurFactoryContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    dispatch(fetchPageData({ page_id: 9, lang: "en" }));
  }, [dispatch]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");
  return (
    <>
      <LoaderWrap>
        <div className="OurFactoryContainer">
          <section>
            <OurFactoryS1 section1={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurFactoryS2">
            <OurFactoryS2 section2={section2} contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurFactoryS3">
            <OurFactoryS3 section3={section3} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function OurFactoryS1({ section1 }) {
  const sentences = section1?.description?.split(".").filter(Boolean) || [];

  const Para = sentences.map((s) => s.trim()).join(".<br /><br />") + ".";
  return (
    <>
      <div className="OurFactoryS1">
        <TC3L
          Head="Our Factory"
          Title={section1?.title}
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaWidth="56vw"
          ParaWidthMob="89vw"
        />
        <div className="OFS1P2">
          <ImgBox ImgSrc={section1?.image} ImgAlt="" imgHeight="50vw" />
        </div>
      </div>
    </>
  );
}

function OurFactoryS2({ section2, contents }) {
  return (
    <>
      <div className="OurFactoryS2">
        <TC3L Title={section2?.title} TitleWidthMob="89vw" Para={section2?.description} ParaWidth="56vw" ParaWidthMob="89vw" />
        <div className="OFS2P2">
          {contents?.map((item) => (
            <OFS2P2Box key={item.id} Title={item.title} Description={item.description} imgSrc={item.image} imgAlt={item.title} />
          ))}
        </div>
      </div>
    </>
  );
}

function OFS2P2Box({ imgSrc, imgAlt, Title, Description }) {
  return (
    <>
      <div className="OFS2P2Box">
        <div className="OFS2P2BoxP1">
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className="OFS2P2BoxP2 TGLo32PxPC">{Title}</div>
        <div className="OFS2P2BoxP3 TFut20PxPC">{Description}</div>
      </div>
    </>
  );
}

function OurFactoryS3({ section3 }) {
  return (
    <>
      <div className="OurFactoryS3">
        <ILTCBox
          Title={section3?.title}
          TextAlign={"left"}
          TitleWidth=""
          Para={section3?.description}
          ParaWidth=""
          ImgSrc={section3?.image}
          ImgOrder="-1"
          ImgAlt={section3?.title}
        />
      </div>
    </>
  );
}
